import { nanoid } from "nanoid";

const CLIENT_REF_STORAGE_KEY = "oze-subscriptions-client-ref";

export function getClientRef(): string {
  if (process.env.REACT_APP_CLIENT_REF) {
    return process.env.REACT_APP_CLIENT_REF;
  }

  if (typeof window === "undefined") {
    return "subscriptions-web";
  }

  try {
    let clientRef = sessionStorage.getItem(CLIENT_REF_STORAGE_KEY);
    if (!clientRef) {
      clientRef = `subscriptions-web-${nanoid()}`;
      sessionStorage.setItem(CLIENT_REF_STORAGE_KEY, clientRef);
    }
    return clientRef;
  } catch {
    return `subscriptions-web-${nanoid()}`;
  }
}
